import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import EntityAgreement from "legal-entities/agreements/entity-agreement";

export default class UpdateEntityAgreementAPIRequest {
  public get payload(): JsonPatchOperation[] {
    return [...this._payload];
  }

  constructor(oldAgreement: EntityAgreement, newAgreement: EntityAgreement) {
    this.updateAgreementAdministrator(newAgreement, oldAgreement);

    if (
      (newAgreement.termsFileId && !oldAgreement.termsFileId) ||
      !oldAgreement.termsFileId?.isEqualTo(newAgreement.termsFileId)
    ) {
      this._payload.push({
        op: "replace",
        path: "/TermsFileId",
        value: newAgreement.termsFileId?.value ?? null,
      });
    }

    if (newAgreement.entityName.value !== oldAgreement.entityName.value) {
      this._payload.push({
        op: "replace",
        path: "/EntityName",
        value: newAgreement.entityName.value,
      });
    }
  }

  private updateAgreementAdministrator(
    newAgreement: EntityAgreement,
    oldAgreement: EntityAgreement
  ) {
    if (
      newAgreement.administratorName &&
      (!oldAgreement.administratorName ||
        (newAgreement.administratorName &&
          !newAgreement.administratorName.isEqualTo(
            oldAgreement.administratorName
          )))
    ) {
      this._payload.push(
        {
          op: "replace",
          path: "/AdministratorFirstName",
          value: newAgreement.administratorName.firstName,
        },
        {
          op: "replace",
          path: "/AdministratorLastName",
          value: newAgreement.administratorName.lastName,
        }
      );
    } else if (
      !newAgreement.administratorName &&
      oldAgreement.administratorName
    ) {
      this._payload.push(
        {
          op: "replace",
          path: "/AdministratorFirstName",
          value: null,
        },
        {
          op: "replace",
          path: "/AdministratorLastName",
          value: null,
        });
    }

    if (newAgreement.administratorEmail && !oldAgreement.administratorEmail) {
      this._payload.push({
        op: "replace",
        path: "/AdministratorEmail",
        value: newAgreement.administratorEmail.value,
      });
    } else if (
      !newAgreement.administratorEmail &&
      oldAgreement.administratorEmail
    ) {
      this._payload.push({
        op: "replace",
        path: "/AdministratorEmail",
        value: null,
      });
    }
  }

  private readonly _payload: JsonPatchOperation[] = [];
}
